import { EnvVariablesModule } from "@pharaday/env";
import { Container, ContainerModule } from "inversify";
import "reflect-metadata";

import { AuthenticatorProvider, AuthProvider } from "./application";
import { FakeAuthenticatorProvider, NextAuthProvider, RestAuthenticatorProvider } from "./infrastructure";
import { NextAuthClientProvider } from "./infrastructure/auth-provider/next-auth-client.provider";

export const AuthContainer = new Container({ defaultScope: "Singleton" });

AuthContainer.load(EnvVariablesModule);

// Create a singleton client-side auth provider instance for browser environments
const clientAuthProvider = new NextAuthClientProvider();

export const AuthModule = new ContainerModule(({ bind }) => {
  // Bind AuthProvider with runtime environment detection
  bind(AuthProvider).toDynamicValue(() => {
    const isClient = typeof window !== "undefined";
    return isClient ? clientAuthProvider : new NextAuthProvider();
  });
});

export const AuthenticatorModule = new ContainerModule(({ bind }) => {
  bind(AuthenticatorProvider).toDynamicValue(() => {
    if (process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true") {
      const provider = new FakeAuthenticatorProvider();
      provider.addEmailFixtures("dev@pharaday.net");
      return provider;
    }
    return new RestAuthenticatorProvider();
  });
});

AuthContainer.load(AuthModule, AuthenticatorModule);
